module.exports = __webpack_public_path__ + "static/media/Agenda-Day-01.ef570655.jpg";